import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LocalVariable } from '../_helpers/localvariable';


@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

	constructor(private router: Router) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if(LocalVariable.isLoggedIn()){
			return true;
		}
		else{
			this.router.navigate(['/login']);
			return false;
		}
	}

}

@Injectable({
    providedIn: 'root'
})
export class AuthGuardHomepage implements CanActivate {

	constructor(private router: Router) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if(LocalVariable.isLoggedIn()){
			this.router.navigate(['/dashboard']);
			return false;
		}
		else{
			return true;
		}
	}

}